import { VevProps } from './vev-props';
import { OAuthConfig } from './oauth';

// KV types
type KeyPart = string | number | bigint | boolean | symbol;

export type EditorPluginKvKey = KeyPart[];

interface EditorPluginKvCommitResult {
  ok: true;
  versionstamp: string;
}

interface EditorPluginKvEntry<T> {
  key: EditorPluginKvKey;
  value: T;
  versionstamp: string;
}

export interface EditorPluginKv {
  set: (key: EditorPluginKvKey, value: unknown) => Promise<EditorPluginKvCommitResult>;
  get: <T>(key: EditorPluginKvKey) => Promise<EditorPluginKvEntry<T>>;
  delete: (key: EditorPluginKvKey) => Promise<void>;
}

// Vev plugin types
export interface EditorPluginSettings {
  form: VevProps[];
}

export interface EditorPluginAssetSourceResult {
  images?: {
    key: string;
    name: string;
    url: string;
    thumb: string;
    metadata?: Record<string, string | number>;
  }[];
  videos?: {
    key: string;
    name: string;
    url: string;
    thumb: string;
    metadata: Record<string, string | number>;
  }[];
  shapes?: {
    key: string;
    name: string;
    url: string;
    thumb: string;
    metadata: Record<string, string | number>;
  }[];
}

export enum EditorPluginType {
  ASSET_SOURCE = 'asset-source',
}

export interface EditorPlugin<T> {
  id: string;
  name: string;
  type: EditorPluginType;
  form: VevProps[];
  handler: (
    request: Request,
    env: Record<string, string>,
    kv: EditorPluginKv,
  ) => Promise<T | EditorPluginSettings>;
  icon?: string;
  oauthConfig?: OAuthConfig;
}

export interface EditorPluginAssetSource extends EditorPlugin<EditorPluginAssetSourceResult> {
  type: EditorPluginType.ASSET_SOURCE;
}

export type VevPluginType = EditorPluginAssetSource;
